<template>
  <div
    v-if="
      (jwtAccessValid() && userProfile.checked && (isWholesaler || isDriver)) || isAdmin || isManager
    "
    class="container px-1 justify-content-center"
    style="max-width: 400px"
  >
    <div class="sticky">
      <h1 class="text-center">
        АКТЫ ПЕРЕМЕЩЕНИЯ
      </h1>
      <div class="row-cols-1">
        <div v-if="isAdmin" class="col mt-1">
          <router-link
            v-if="!isManager"
            class="btn btn-lg btn-primary w-100 text-center berry"
            type="button"
            tag="button"
            :to="{ name: 'shipment', params: { id: 'new' } }"
          >
            ДОБАВИТЬ
          </router-link>
        </div>

        <div class="col mt-1">
          <Multiselect
            v-model="currentMaster"
            :options="usersWholesaler"
            :loading="false"
            :internal-search="false"
            valueProp="_id"
            trackBy="fullname"
            label="fullname"
            :filterResults="true"
            :minChars="2"
            :resolveOnLoad="true"
            :searchable="true"
            class="deliverer"
            noOptionsText="Не найден"
            placeholder="Оптовик"
          >
          </Multiselect>
        </div>

        <div class="col mt-1">
          <input class="form-control" placeholder="Поиск" v-model="searchText" type="text" />
        </div>
      </div>
    </div>

    <div
      v-for="doc in docsFilter"
      :key="doc._id"
      class="card lh-1 mt-3"
      :class="{ canceled: doc.cancel }"
      @click="router.push({ name: 'shipment', params: { id: doc._id } })"
    >
      <div class="card-body">
        <div class="row row-cols-2">
          <div class="col text-muted">Дата</div>
          <div class="col text-muted">Номер</div>
          <div class="col">
            <span>{{ new Date(doc.date).toLocaleString() }}</span>
          </div>
          <div class="col">
            <span>{{ `${doc.prefix}-${doc.number}` }}</span>
          </div>
        </div>

        <div class="row row-cols-1 pt-2">
          <div class="col text-center">
            <span class="fs-3" v-if="doc.tableUnit[0].berry"
              ><strong>{{ doc.tableUnit[0].berry.label }}</strong></span
            >
          </div>
        </div>

        <div class="row pt-2 row-cols-1">
          <div class="col text-muted text-center">Вес, кг</div>
          <div class="col pt-1 text-center">
            <span class="fs-2 text-center">{{ doc.tableUnit[0].weight.toFixed(2) }}</span>
          </div>
        </div>

        <div class="row row-cols-1 pt-2">
          <div class="col text-muted"><small>Оптовик</small></div>
          <div class="col">
            <span v-if="doc.company && doc.company.receiver">{{
              doc.company.receiver.masterFullname
            }}</span>
          </div>
        </div>

        <div class="row row-cols-1 pt-2">
          <div class="col text-muted"><small>Приемщик</small></div>
          <div class="col">
            <span v-if="doc.company && doc.company.receiver">{{
              doc.company.receiver.fullname
            }}</span>
          </div>
        </div>

        <div class="row row-cols-2 pt-2">
          <div class="col text-muted"><small>Доставлено</small></div>
          <div class="col"><font-awesome-icon v-if="doc.closed" icon="check" /></div>
        </div>

        <div class="row row-cols-1 pt-2">
          <div class="col text-center">
            <span>{{ doc.comment }}</span>
          </div>
        </div>

        <div v-if="doc.cancel" class="row row-cols-1 pt-2">
          <div class="col text-center">
            <span><strong>ОТМЕНЕН</strong></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import useCommonMixin from "@/components/commonMixin.js";
import Multiselect from "@vueform/multiselect";

export default {
  name: "ShipmentsCard",
  components: { Multiselect },
  props: {},

  setup(props) {
    useCommonMixin();
    const {
      jwtAccessValid,
      asyncForEach,
      isReciever,
      userProfile,
      isAdmin,
      isManager,
      isDriver,
      isWholesaler,
    } = useCommonMixin();
    const store = useStore();
    const router = useRouter();
    const docs = ref([]);
    const profiles = ref([{}]);

    const users = ref([]);
    const roles = ref([]);
    const currentMaster = ref();
    const searchText = ref("");

    const init = async () => {
      let response = await store.dispatch("FETCHshipment");
      docs.value = response.status ? response.data : [];

      response = await store.dispatch("FETCHuser", "receiver");
      users.value = response.status ? response.data : [];
      asyncForEach(users.value, async user => {
        user.phone = user.phone ? user.phone.slice(2, 12) : "";
        user.fullname = user.receiver.fullname;
      });

      let responseRoles = await store.dispatch("FETCHroles");
      roles.value = responseRoles.status
        ? responseRoles.data.filter(role => role.type != "deliverer")
        : [];
    };

    const usersWholesaler = computed(() => {
      let wholesalerRole = roles.value.find(item => item.name == "wholesaler");
      let receiverRole = roles.value.find(item => item.name == "receiver");

      let result = [];
      if (wholesalerRole && receiverRole) {
        result = users.value.filter(
          item => item.role == wholesalerRole._id || item.role == receiverRole._id
        );
      }
      return result;
    });

    const docsFilter = computed(() => {
      let result = docs.value;

      if (currentMaster.value) {
        result = result.filter(doc => {
          return doc.company ? doc.company._id == currentMaster.value : false;
        });
      }
      if (searchText.value.length >= 3) {
        result = result.filter(
          doc =>
            JSON.stringify(doc)
              .toLowerCase()
              .indexOf(searchText.value.toLowerCase()) >= 0
        );
      }
      return result;
    });

    onMounted(init);

    return {
      jwtAccessValid,
      isReciever,
      docs,
      profiles,
      router,
      userProfile,
      isAdmin,
      isManager,
      docsFilter,
      usersWholesaler,
      searchText,
      currentMaster,
      isDriver,
      isWholesaler
    };
  }
};
</script>

<style>
.canceled {
  background-color: #e44d4d6b !important;
}
</style>
